<template>
  <div class="push_sidebar widget-name" v-if="user">
    <div class="modal" ref="modalInfo" role="dialog">
      <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 v-if="datosPlato"><b class="text-primary">Información nutricional de {{datosPlato.nombre}}</b></h4>
                </div>
                  <div class="modal-body" v-if="datosPlato&&datosPlato.receta">
                          <div class="row" v-if="datosPlato.receta.edamam.totals">
                                <div class="col-md-12 text-center">
                                  <!--
                                  <section class="performance-facts" id="performance-facts">
                                      <div class="performance-facts__header">
                                          <h1 class="performance-facts__title">Información nutricional</h1>
                                      </div>
                                      <table class="performance-facts__table">
                                          <thead>
                                              <tr>
                                                  <th colspan="3" class="amps">Cantidades por Porción</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <th colspan="2" id="lkcal-val-cal"><b>Calorias</b></th>
                                                  <td class="nob">{{datosPlato.receta.edamam.totals.totalCal}}</td>
                                              </tr>
                                              <tr class="thick-row">
                                                  <td colspan="3" class="small-info"><b>% del valor diario*</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Grasas totales</b> {{datosPlato.receta.edamam.totals.FAT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFAT}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Grasas Saturadas {{datosPlato.receta.edamam.totals.FASAT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFASAT}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Grasas Trans {{datosPlato.receta.edamam.totals.FATRN}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Colesterol</b> {{datosPlato.receta.edamam.totals.CHOLE}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCHOLE}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Sodio</b> {{datosPlato.receta.edamam.totals.NA}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyNA}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th colspan="2"><b>Carbohidratos totales</b> {{datosPlato.receta.edamam.totals.CHOCDF}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCHOCDF}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Fibra {{datosPlato.receta.edamam.totals.FIBTG}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFIBTG}}</b></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Azúcares {{datosPlato.receta.edamam.totals.SUGAR}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr>
                                                  <td class="blank-cell"></td>
                                                  <th>Azúcar agregada {{datosPlato.receta.edamam.totals.SUGARadded}}</th>
                                                  <td></td>
                                              </tr>
                                              <tr class="thick-end">
                                                  <th colspan="2"><b>Proteínas</b> {{datosPlato.receta.edamam.totals.PROCNT}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyPROCNT}}</b></td>
                                              </tr>
                                          </tbody>
                                      </table>
                                      <table class="performance-facts__table--grid">
                                          <tbody>
                                              <tr>
                                                  <th>Vitamin D {{datosPlato.receta.edamam.totals.VITD}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyVITD}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th>Calcio {{datosPlato.receta.edamam.totals.CA}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyCA}}</b></td>
                                              </tr>
                                              <tr>
                                                  <th>Hierro {{datosPlato.receta.edamam.totals.FE}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyFE}}</b></td>
                                              </tr>
                                              <tr class="thin-end">
                                                  <th>Potasio {{datosPlato.receta.edamam.totals.K}}</th>
                                                  <td><b>{{datosPlato.receta.edamam.totals.totalDailyK}}</b></td>
                                              </tr>
                                          </tbody>
                                      </table>
                                      <p class="small-info" id="small-nutrition-info">* Porcentaje de valor diario calculado sobre la base de una dieta de 2000 calorías</p>
                                  </section>
                                  -->
    <graph-pie
            :width="350"
            :height="350"
            :padding-top="50"
            :padding-right="50"
            :padding-bottom="75"
            :padding-left="50"
            :values="nutritionalValues"
            :names="nutritionalLabels"
            :active-event="'click'"
            :show-text-type="'outside'"
            :data-format="dataFormat"
            :colors="[ '#93A512', '#74A9B3', '#F28893']"
            :shape="'donut'"
            :show-total-value="true">
        <note :text="nutritionalTotal" :size="20" :color="'#66277b'"></note>            
        <legends :names="nutritionalLabels"></legends>
        <tooltip :names="nutritionalLabels"></tooltip>
    </graph-pie>
                                  
                                </div>
                          </div>                    
                  </div>
            </div>
      </div>
    </div>


    <header class="calendar">
        <div class="container">
          <div class="row">
            <div class="visible-lg col-lg-2 head-actions-left">
              <div class="dropdown pull-left change-city">
                <!--
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="fa fa-map-marker"></i> Ciudad <i class="fa fa-angle-down"></i></a>
                <ul class="dropdown-menu">
                <li v-for="proveedor in proveedores"><a href="">Córdoba</a></li>
                <li><a href="">Rosario</a></li>
                <li><a href="">Capital Federal</a></li>
                </ul>
                -->               
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-8">
              <div class="date-picker">
                <div class="date-picker-dates owl-carousel" ref="calendar_menu">
                <div class="item" v-for="dia in dias" :class="{ current: dia === diaActivo}" :key="dia">
                  <i class="highlight fa fa-check-circle" v-if="pedidosProgramados[dia]" data-position="bottom" :id="'tip' + dia" @mouseover="mostrarTooltip('tip' + dia)" data-toggle="tooltip" rel="tooltip" data-placement="bottom" data-original-title="PEDIDOS PROGRAMADOS" title="PEDIDOS PROGRAMADOS"></i>
                  <a class="cutoff-date-option" href="#" @click.prevent="setDia(dia)">
                  <div class="date">
                    <div class="day-of-week mobile">{{dia | diaNombreMobile}}</div>
                    <div class="day-of-week desktop">{{dia | diaNombreDesktop}}</div>
                    <div class="day-of-month">{{dia | diaNumero}}</div>
                  </div>
                  </a>
                </div>
                </div>
              </div>
            </div>
            <div class="hidden-xs hidden-sm col-md-3 col-lg-2 head-actions-right">
              <div class="pull-right menu-print">
                <a @click.prevent="imprimirMenu"><i class="icon-print"></i></a>
              </div>
              <!--
              <div class="dropdown pull-right menu-filter">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="icon-filter"></i></a>
                <ul class="dropdown-menu">
                <li><a href="#">Vegetariano</a></li>
                <li><a href="#">Vegano</a></li>
                <li><a href="#">Sin Picante</a></li>
                <li><a href="#"> Sin Gluten</a></li>
                <li><a href="#">Sin Huevo</a></li>
                </ul>
              </div>
              -->
             </div>
          </div>
        </div>
    </header><!-- fin Header Calendario -->
    <div class="main-alert" v-if="menuActivo && asignacionActiva && precioCombo">
      <div class="container">
        <div class="alert-box">
          <span class="">PUEDES PEDIR {{reglasATexto}} POR UN VALOR DE ${{precioCombo.precio}}/DÍA. LA EMPRESA ABONA EL {{subsidioDia}}% DEL VALOR DE TUS PEDIDOS</span>
          <span class="hide">PUEDES PEDIR TU PLATO PRINCIPAL + POSTRE POR UN VALOR DE $75/DÍA. LA EMPRESA ABONARÁ EL 50% DEL VALOR DE TUS PEDIDOS DE TU RECIBO DE SUELDO</span> 
        </div>
        <div class="text-center center-block">
          <div class="btn-group botonera">
            <a class="btn btn-link dietary-tag">Todos</a>
            <a class="btn btn-link dietary-tag"><i class="icon-vegan"></i> Vegano</a>
            <a class="btn btn-link dietary-tag"><i class="icon-vegetarian"></i> Vegetariano</a>
            <a class="btn btn-link dietary-tag"><i class="icon-spice"></i> Picante</a>
            <a class="btn btn-link dietary-tag"><i class="icon-celiac"></i> Sin gluten</a>
          </div>
        </div>
        
      </div>
    </div>
    <section class="menu-section menu-content" >
      <div class="container" v-if="cargando">
        <div class="col-xs-12 col-sm-4" v-for="n in 3" :key="n">
          <div class="mocka-container" style="width: 100%;">
            <span class="mocka-heading"></span>
            <span class="mocka-media" style="width: 85%;"></span>
            <br>
            <span class="mocka-text"></span>
            <span class="mocka-text"></span>
            <span class="mocka-text"></span>
          </div>
        </div>
      </div>
      <div class="container">
        <!--
        <select ref="comboProveedores" @change="setProveedorActivo" class="form-control" v-if="proveedorActivo && carrito.length === 0">
          <option :value="proveedor._id"  :key="proveedor._id" v-for="proveedor in proveedores">{{proveedor.combo.nombre}}</option>
        </select>
        -->
        <ul class="nav nav-pills text-center center-block" v-if="asignacionActiva && carrito.length === 0" style="margin-bottom: 40px;margin-top: 20px;">
          <li role="presentation" v-for="proveedor in proveedores" :class="{active: proveedor._id === asignacionActiva._id}">
            <a href="" class="btn btn-outline" @click.prevent="setProveedorActivo(proveedor._id)" style="height: 32px;">
              {{proveedor.combo.nombre}}
                <!--
                <ul class="list-unstyled" >
                  <li v-for="regla in proveedor.combo.reglas">
                    <span class="label" v-if="proveedor._id === asignacionActiva._id">{{regla.cantidad}}x {{regla.categoria.nombre}}</span>
                    <span class="label label-info" v-else>{{regla.cantidad}}x {{regla.categoria.nombre}}</span>
                  </li>
                </ul>
                -->
            </a>
          </li>
        </ul>
      </div>
      <template v-if="!pedidosProgramados[diaActivo] || user.roles[0] === 'admincliente'">
        <div class="container" v-if="menusMostrar.categorias">
          <!-- Contenedor categoría de menú -->
            <section class="menu-section"  v-for="categoria, idxCategoria in menusMostrar.categorias"  :key="categoria._id">
              <div class="menu-section-head">{{categoria.nombre}} <small v-if="menusMostrar.enabled">({{itemsCarritoCategoria(menuActivo.fecha, categoria._id)}})</small></div>
              
              <!-- Lista de platos -->
              <ul class="menu-items row" v-if="platosAgrupadosCategoria[categoria._id].length > 0">
                
                <!-- Plato -->
                <li class="menu-item" v-for="plato, idxListItem in platosAgrupadosCategoria[categoria._id]" :key="plato._id">
                  <div class="item-img-container" v-if="plato.proveedor" :ref="'plato' + idxCategoria + ' ' + idxListItem" 
                    :class="{sin: plato.cantidad === 0}" @mouseover="mostrarHover('plato' + idxCategoria + ' ' + idxListItem, plato.cantidad)" 
                    @mouseleave="esconderHover('plato' + idxCategoria + ' ' + idxListItem, plato.cantidad)">
                    <div class="item-img photo" :source="plato.urlThumb" style='background-size: cover; background-position: center;' :style="{backgroundImage: 'url(' + plato.urlThumb + ')', opacity:menusMostrar.enabled?1:0.4}">
                      <div class="item-caption">
                        <div class="item-description">
                          <a class="item-link">
                            <p class="item-name-desc open">{{plato.nombre}}</p>
                            <p class="item-subname-desc">{{plato.descripcion}}</p>
                            <p class="item-desc">{{plato.observaciones}}</p>
                          </a>
                        </div>
                        <div class="item-quantity" :class="{hide: plato.cantidad === 0}">
                          <div class="alert-add">AGREGADO A TU LISTA!</div>
                          <div class="quantity-actions">
                            <div class="quantity">
                              <a class="decrease" @click.prevent="disminuir(menusMostrar.fecha, plato)">–</a>
                              <span class="qty-value">{{plato.cantidad}}</span>
                              <a class="increase" @click.prevent="agregarAlCarrito(diaActivo, plato)">+</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-details">
                    <h2 class="item-name open" :class="{disabled: !menusMostrar.enabled}">{{plato.nombre}}</h2>
                    <!-- <p class="item-provider">Beto's</p> -->
                    <footer>
                      <!-- <div class="price">$25.99</div> -->
                      <div class="right-actions">
                        <span class="actions" v-if="menusMostrar.enabled">
                        <b class="pull-left">{{disponibles(diaActivo, plato)}}</b>
                        <button class="btn btn-sm btn-outline add-to-cart" title="Agregar a mis pedidos" @click="agregarAlCarrito(diaActivo, plato)" v-if="puedeAgregar(diaActivo, plato) && plato.cantidad === 0">
                          AGREGAR 
                        </button>
                        <button class="btn btn-sm btn-outline btn-quit add-to-cart" v-if="plato.cantidad > 0" title="Quitar de mis pedidos" @click.prevent="disminuir(menusMostrar.fecha, plato)">
                            QUITAR
                        </button>
                        </span>
                        <div class="dietary-tag">
                          <i class="icon-celiac" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="APTO CELÍACOS" title="APTO CELÍACOS" v-if="plato.aptoCeliacos"></i>
                          <i class="icon-spice" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="PICANTE" title="PICANTE" v-if="plato.picante"></i>
                          <i class="icon-vegetarian" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="VEGETARIANO" title="VEGETARIANO" v-if="plato.vegetariano"></i>
                          <i class="icon-vegan" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="100% VEGANO" title="100% VEGANO" v-if="plato.vegano"></i>
                          <span @click="showNutritionalInfo(plato)" class="nutritional-info" v-if="plato.receta&&plato.receta.edamam&&plato.receta.edamam.totals" data-toggle="tooltip" rel="tooltip" data-placement="top" data-original-title="Ver Información nutricional" title="Ver Información nutricional">
                            Calorias: {{plato.receta.edamam.totals.totalCal}}
                          </span>
                        </div>
                      </div>
                    </footer>
                  </div>
                </li><!-- Fin Plato -->
              </ul><!-- Fin Lista de Platos -->
              <template v-else>
                <div class="text-center center-block placeholder">
                  <h1> No hay platos de la categoría para esta fecha</h1>
                </div>
              </template>
            </section><!-- Fin contenedor categoría de menú -->
            <div class="nav-week-footer" v-if="dias.length > 0">
              <a class="nwf-left" v-if="idxDia > 0" href="#" @click.prevent="setDia(dias[idxDia -1])">
                <i class="icon-arrow-left"></i>
                <span>{{dias[idxDia - 1] | formatFechaNavegador}}</span>
              </a>
              <a class="nwf-right" v-if="0 < (dias.length -1)" href="#" @click.prevent="setDia(dias[idxDia + 1])">
                <span>{{dias[idxDia + 1] | formatFechaNavegador}}</span>
                <i class="icon-arrow-right"></i>					
              </a>
            </div>
        </div>
        <div class="container" v-else>
            <h1 class="text-center center-block">No hay platos para esta fecha</h1>
            <div class="nav-week-footer" v-if="dias.length > 0">
              <a class="nwf-left" v-if="idxDia > 0" href="#" @click.prevent="setDia(dias[idxDia -1])">
                <i class="icon-arrow-left"></i>
                <span>{{dias[idxDia - 1] | formatFechaNavegador}}</span>
              </a>
              <a class="nwf-right" v-if="0 < (dias.length -1)" href="#" @click.prevent="setDia(dias[idxDia + 1])">
                <span>{{dias[idxDia + 1] | formatFechaNavegador}}</span>
                <i class="icon-arrow-right"></i>          
              </a>
            </div>          
        </div>
      </template>
      <template v-else>
        <h1 class="text-center center-block">Ya tienes pedidos para esta fecha</h1>
      </template>
    </section>

    <div class="box-text centered only-admin" v-if="user.roles[0] === 'admincliente'">
      <p class="size-16">¿Deseas agregar una persona a tu cuenta de administrador?</p>
      <p><router-link to="/newuser" class="btn btn-fill margin-bottom-30">CREAR CUENTA</router-link></p>
    </div>
    <div ref="menuDia" v-if="menuActivo" class="hidden">
      <h2 class="text-center">Menú del día {{diaActivo | formatFechaNavegador}} en andalepide</h2>
      <div v-for="categoria, idxCategoria in menuActivo.categorias">
        <h4 style="text-decoration: underline;">{{categoria.nombre}}</h4>
        <ul class="list-unstyled">
          <li v-for="plato, idxListItem in filtroCategoria(categoria)" :key="plato._id">
            <span>{{plato.nombre}}</span>
            <table class="table">
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            </li>
        </ul>
      </div>
    </div>
  </div>


</template>
<script>
  import 'owl.carousel/dist/assets/owl.carousel.css'
  import $ from 'jquery'
  import 'owl.carousel'
  import _ from 'lodash'
  import moment from 'moment'
  import 'moment-timezone'
  import 'mocka-placeholder'
  import mixinClases from '../../mixins/UserLogged.js'
  import mixinsCarrito from '../../mixins/Carrito.js'
  import mixinsCheckUser from '../../mixins/CheckUser.js'
  import PHE from 'print-html-element'
  import localforage from 'localforage'
  import 'tippy.js/dist/tippy.css'
  import tippy from 'tippy.js'
  export default {
    mixins: [mixinClases, mixinsCarrito, mixinsCheckUser],
    data () {
      return {
        agruparCarrito: false,
        cargando: false,
        datosPlato: undefined,
        stock: {},
        // categoriasObject: [],
        // categoriasCombo: undefined,
        comboActivo: null,
        diaActivo: undefined,
        dias: [],
        idxDia: -1,
        itemActivo: undefined,
        itemsPedido: [],
        menus: [],
        nutritionalValues: [],
        nutritionalTotal: '',
        nutritionalLabels: ['Proteinas', 'Carbohidratos', 'Grasas'],
        // precioCombo: undefined,
        proveedor: undefined,
        asignacionActiva: null,
        proveedores: [],
        subsidio: null,
        titleCompleto: 'El pedido está completo o vacío para este día',
        titleIncompleto: 'El pedido está incompleto para este día, agregue los items de las categorías que faltan',
        userData: undefined,
        pedidosRealizados: []
      }
    },
    computed: {
      platosAgrupadosCategoria () {
        const me = this
        if (!me.menusMostrar) return []
        if (!me.menusMostrar.categorias) {
          return {}
        }
        let categorias = {}
        me.menusMostrar.categorias.forEach((categoria) => {
          categorias[categoria._id] = me.menusMostrar.platos.filter((plato) => {
            return plato.categoria._id === categoria._id
          })
        })
        return categorias
      },
      reglasATexto () {
        let texto = ''
        const me = this
        if (me.reglasActivas) {
          // texto = me.subsidio.comboAsignado.reglas.map((regla) => { return regla.cantidad + ' ' + regla.categoria.nombre.toUpperCase() }).join(' + ')
          texto = me.reglasActivas.map((regla) => { return regla.cantidad + ' ' + regla.categoria.nombre.toUpperCase() }).join(' + ')
        }
        return texto
      },
      menuActivo () {
        const me = this
        if (!me.diaActivo) {
          return false
        }
        var diaFormateado = moment(new Date(me.diaActivo)).utc().format('DD/MM/YYYY')
        let menuActivo = me.menus.find((itemMenu) => {
          return itemMenu.diaFormateado === diaFormateado
        })
        return menuActivo
      },
      menusMostrar () {
        const me = this
        const enabledFrom = moment(me.enabledFrom).valueOf()
        let menu = {}
        if (me.asignacionActiva && me.menuActivo) {
          let categorias = me.asignacionActiva.combo.reglas.map((regla) => {
            return regla.categoria
          })
          let ids = categorias.map((categoria) => {
            return categoria._id
          })
          let platos = me.menuActivo.platos.filter((plato) => {
            return ids.includes(plato.categoria._id)
          })
          menu.categorias = _.sortBy(categorias, (categoria) => {
            return categoria.nombre
          })
          menu.platos = platos
          menu.fecha = me.diaActivo
          menu.enabled = (moment(menu.fecha).valueOf() - enabledFrom) > -1
          menu.fechaFormateada = moment(new Date(menu.fecha)).format('YYYY-MM-DD')
        }
        return menu
      },
      pedidosProgramados () {
        console.log('pedidosProgramados')
        const me = this
        let resultado = {}
        me.dias.forEach((dia) => {
          let hayPedidos = me.pedidosRealizados.some((pedido) => {
            const fechaPedido = moment(new Date(pedido.fechaEntrega)).format('DD-MM-YYYY')
            const fechaComparar = moment(new Date(dia)).utc().format('DD-MM-YYYY')
            return fechaPedido === fechaComparar && me.comboActivo === pedido.combo && pedido.usuario === me.user._id
          })
          resultado[dia] = hayPedidos
        })
        return resultado
      },
      precioCombo () {
        const me = this
        if (!me.asignacionActiva) {
          return {}
        }
        let precio = me.asignacionActiva.proveedor.precios.find((precio) => {
          return precio.combo._id === me.comboActivo
        })
        localforage.setItem(`precio-activo-${me.user._id}`, precio)
        .then(() => {
          return precio
        })
      },
      reglasActivas () {
        const me = this
        let reglas = []
        if (me.asignacionActiva) {
          reglas = me.asignacionActiva.combo.reglas
        }
        localforage.setItem(`reglas-${me.user._id}`, reglas).then(() => {
          return reglas
        })
      },
      reglas () {
        return this.subsidio.comboAsignado.reglas
      },
      categoriasCombo () {
        // let reglas = this.reglas.map((regla) => {
        let reglas = this.reglasActivas.map((regla) => {
          return regla.categoria._id
        })
        return reglas
      },
      reglasObject () {
        let reglas = this.reglasActivas.map((regla) => {
          return regla.categoria
        })
        return reglas
      },
      subsidioDia () {
        const me = this
        let porcentaje = 0
        if (me.subsidio) {
          porcentaje = me.subsidio[moment(me.diaActivo).format('dddd')]
        }
        return porcentaje
      }
    },
    props: ['carrito', 'user'],
    filters: {
      diaNombreDesktop (value) {
        return moment(new Date(value)).utc().format('ddd')
      },
      diaNombreMobile (value) {
        return moment(new Date(value)).utc().format('dd')
      },
      diaNumero (value) {
        return moment(new Date(value)).utc().format('DD')
      },
      formatFechaNavegador (value) {
        return moment(new Date(value)).utc().format('ddd').toUpperCase() + ' ' + moment(new Date(value)).utc().format('DD/MM')
      }
    },
    mounted () {
      $('body').addClass('user-sesion daily-menu')
      const me = this
      me.cargando = true
      localforage.getItem(`proveedor-activo-${me.user._id}`)
      .then((proveedor) => {
        return proveedor
      })
      .then((proveedor) => {
        this.$http.get('/api/pedidos/initpedido', {
          params: {
            time: +new Date()
          }
        }).then(({body}) => {
          console.log('body', body)
          me.dias = body.dias
          me.stock = {}
          body.stock.forEach((stock) => {
            me.stock[stock.fechaFormateada + '_' + stock.plato] = stock
          })
          const menus = body.menus
          me.userData = body.userData
          me.proveedores = body.proveedores
          me.enabledFrom = me.dias[body.todayPosition]
          me.pedidosRealizados = body.pedidosRealizados
          if (proveedor) {
            me.asignacionActiva = proveedor
          } else {
            me.asignacionActiva = me.proveedores[0]
          }
          me.subsidio = me.asignacionActiva.subsidio
          // me.subsidio = me.proveedores[0].subsidio
          me.comboActivo = me.asignacionActiva.combo._id
          /*
          me.precioCombo = me.proveedores[0].proveedor.precios.find((precio) => {
            return precio.combo._id === me.comboActivo
          })
          */
          // me.reglas = me.subsidio.comboAsignado.reglas
          // me.categoriasObject = me.reglas.map((regla) => {
            // return regla.categoria
          // })
          // me.categoriasCombo = me.reglas.map((regla) => {
            // return regla.categoria._id
          // })
          menus.forEach((itemMenu) => {
            itemMenu.diaFormateado = moment(new Date(itemMenu.fecha)).utc().format('DD/MM/YYYY')
            let categoriasMenu = itemMenu.platos.map((plato) => {
              plato.cantidad = me.getCantidadEnCarritoDia(itemMenu.fecha, plato._id)
              return plato.categoria
            })
            let categorias = _.uniqBy(categoriasMenu, (e) => {
              return e._id
            })
            itemMenu.categorias = _.sortBy(categorias, 'nombre')
          })
          me.menus = menus
          me.diaActivo = me.dias[body.todayPosition] || null
        }, (error) => {
          console.log(error)
        })
        .then(() => {
          me.setDia(me.diaActivo)
          $(this.$refs.calendar_menu).owlCarousel({
            margin: 0,
            nav: true,
            slideBy: 5,
            startPosition: me.idxDia,
            loop: false,
            navText: ['<span />', '<span />'],
            responsive: {
              0: {
                items: 5
              }
            }
          })
          $('.item-img-container.sin').hover(
            function () {
              $(this).find('.item-description').fadeIn(250)
            },
            function () {
              $(this).find('.item-description').fadeOut(250)
            }
          )
          me.cargarTooltips()
          me.cargando = false
        })
      })
    },
    methods: {
      dataFormat (a, b) {
        // const me = this
        if (b) {
          return b.toFixed(2) + ' %'
        }
        return ''
      },
      showNutritionalInfo (plato) {
        const me = this
        me.datosPlato = plato
        let pro = parseFloat(plato.receta.edamam.totals.PROCNT.split(' ')[0])
        let cho = parseFloat(plato.receta.edamam.totals.CHOCDF.split(' ')[0])
        let fat = parseFloat(plato.receta.edamam.totals.FAT.split(' ')[0])
        let total = pro + cho + fat
        pro = (pro / total) * 100
        cho = (cho / total) * 100
        fat = (fat / total) * 100
        me.nutritionalValues = [pro, cho, fat]
        me.nutritionalTotal = 'Calorías totales ' + plato.receta.edamam.totals.totalCal
        $(me.$refs.modalInfo).modal()
      },
      puedeAgregar (dia, plato) {
        const me = this
        let day = dia.substring(0, 10) + '_' + plato._id
        if (me.stock[day] && me.stock[day].limited) {
          if (me.stock[day].outOfStock) {
            return false
          } else {
            return me.stock[day].stock > 0
          }
        } else {
          return true
        }
      },
      disponibles: function (dia, plato) {
        const me = this
        let day = dia.substring(0, 10) + '_' + plato._id
        if (me.stock[day] && me.stock[day].limited) {
          if (me.stock[day].outOfStock) {
            return 'SIN STOCK'
          }
          return 'Disponibles: ' + me.stock[day].stock
        } else {
          return ''
        }
      },
      agregarAlCarrito: function (dia, plato) {
        const me = this
        if (!me.puedePedirPlato(dia, plato)) {
          me.$emit('mostrar-notificacion', 'No se pueden agregar más items de esta categoría', 'error')
          return false
        }
        me.$emit('agregar-carrito', dia, plato, me.comboActivo, me.reglas)
      },
      cantidadEnCarritoDia (fecha, idPlato) {
        const me = this
        let cantidad = 0
        const diaCarrito = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === fecha
        })
        if (diaCarrito) {
          diaCarrito.proveedor.forEach((proveedor) => {
            proveedor.platos.forEach((plato) => {
              if (plato._id === idPlato) {
                cantidad += plato.cantidad
              }
            })
          })
        }
        return cantidad
      },
      cargarTooltips () {
        tippy('.highlight', {
          flipDuration: 0,
          theme: 'honeybee',
          popperOptions: {
            modifiers: {
              preventOverflow: {
                enabled: true
              }
            }
          }
        })
      },
      disminuir (dia, plato) {
        const me = this
        me.$emit('disminuir-cantidad', dia, plato)
        let platoMenu = me.menuActivo.platos.find((platoMenu) => {
          return platoMenu._id === plato._id
        })
        platoMenu.cantidad = me.getCantidadEnCarritoDia(dia, plato._id)
      },
      cambiarMultiplicador: function (idxDia, fecha, evt) {
        var valor = parseInt(evt.target.value)
        this.menus[idxDia].multiplicador = valor
        var existeEnCarrito = this.existeDiaEnCarrito(fecha)
        if (existeEnCarrito) {
          existeEnCarrito.multiplicador = valor
        }
      },
      eliminarDelCarrito: function (idxItem, idxProveedor, idxPlato) {
        var itemCarrito = this.carrito[idxItem]
        var proveedor = itemCarrito.proveedor[idxProveedor]
        proveedor.platos.splice(idxPlato)
        if (proveedor.platos.length < 1) itemCarrito.proveedor.splice(idxProveedor)
        if (itemCarrito.proveedor.length < 1) this.carrito.splice(idxItem)
      },
      estaCompletoDia: function (dia) {
        var existeDia = this.existeDiaEnCarrito(dia)
        var estaCompleto = true
        var me = this
        if (existeDia) {
          _.each(me.reglas, function (regla) {
            if (regla.cantidad * existeDia.multiplicador !== me.itemsCarritoCategoria(dia, regla.categoria._id)) {
              estaCompleto = false
            }
          })
        }
        return estaCompleto
      },
      estaCompletoPedido: function () {
        var retorno = true
        var me = this
        _.each(this.carrito, function (itemCarrito) {
          if (!me.estaCompletoDia(moment(itemCarrito.fecha, 'DD/MM/YYYY HH:mm').format())) {
            retorno = false
          }
        })
        return retorno
      },
      existeDiaEnCarrito: function (dia) {
        var existeDia = _.find(this.carrito, function (itemCarritoDia) {
          return moment(itemCarritoDia.fecha, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') === moment(dia).utc().format('DD/MM/YYYY')
        })
        return existeDia
      },
      existeProveedorEnDia: function (itemCarritoDia, idProveedor) {
        var existeProveedor = _.find(itemCarritoDia.proveedor, function (proveedor) {
          return proveedor._id === idProveedor
        })
        return existeProveedor
      },
      existePlatoEnProveedor: function (proveedor, plato) {
        var existePlato = _.find(proveedor.platos, function (platoEnProveedor, idx) {
          platoEnProveedor.idx = idx
          return platoEnProveedor._id === plato._id
        })
        return existePlato
      },
      filtroCategoria (categoria) {
        const me = this
        let platos = me.menusMostrar.platos
        const platosFiltrados = _.filter(platos, function (plato) {
          return plato.categoria._id === categoria._id
        })
        platosFiltrados.forEach((plato) => {
          plato.cantidad = me.getCantidadEnCarritoDia(me.diaActivo, plato._id)
        })
        return platosFiltrados
      },
      getCantidadEnCarritoDia (fecha, idPlato) {
        const me = this
        let cantidad = 0
        const diaCarrito = me.carrito.find((itemCarrito) => {
          return itemCarrito.fecha === fecha
        })
        if (diaCarrito) {
          diaCarrito.proveedor.forEach((proveedor) => {
            proveedor.platos.forEach((plato) => {
              if (plato.plato._id === idPlato) {
                cantidad += plato.cantidad
              }
            })
          })
        }
        return cantidad
      },
      guardarPedido: function () {
        // $('#modalSpinner').modal()
        var me = this
        $.ajax({
          url: '/pedidos/formvue',
          type: 'POST',
          data: {
            carrito: this.carrito,
            arrPlatos: this.arrPlatos
          }
        })
        .done(function (data) {
          me.carrito = []
          // swal('Operación exitosa', 'El pedido se ha guardado correctamente', 'success')
        })
        .fail(function (err) {
          console.log('error', err)
        })
        .always(function () {
          // $('#modalSpinner').modal('hide');
        })
      },
      itemsCarritoCategoria: function (dia, idCategoria) {
        var items = 0
        const me = this
        me.carrito.forEach((itemCarrito) => {
          if (itemCarrito.fecha === dia) {
            itemCarrito.proveedor.forEach((proveedor) => {
              const platosCategoria = proveedor.platos.filter((plato) => {
                return plato.plato.categoria._id === idCategoria
              })
              platosCategoria.forEach((platoCategoria) => {
                items += platoCategoria.cantidad
              })
            })
          }
        })
        return items
      },
      itemsCarritoDia: function (dia, item) {
        var items = 0
        _.each(this.carrito, function (itemCarrito) {
          if (moment(itemCarrito.fecha, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') === moment(dia).utc().format('DD/MM/YYYY')) {
            _.each(itemCarrito.proveedor, function (proveedor) {
              _.each(proveedor.platos, function (plato) {
                if (plato._id === item) {
                  items = plato.cantidad
                  return items
                }
              })
            })
          }
        })
        return items
      },
      itemsPorCategoria: function (idxDia, idCategoria) {
        var multiplicador = this.menus[idxDia].multiplicador
        var regla = _.find(this.reglas, function (regla) {
          return regla.categoria._id === idCategoria
        })
        if (regla) {
          return regla.cantidad * multiplicador
        } else {
          return multiplicador
        }
      },
      imprimirMenu () {
        const me = this
        let el = me.$refs.menuDia
        el.classList.remove('hidden')
        PHE.printElement(el, {
          pageTitle: 'Menu en andalepide'
        })
        el.classList.add('hidden')
      },
      mostrarHover (referencia, cantidad) {
        if (cantidad > 0) {
          return false
        }
        const me = this
        $(me.$refs[referencia]).find('.item-description').fadeIn(250)
      },
      mostrarTooltip (ref) {
        // const me = this
        tippy(document.getElementById(ref))
      },
      esconderHover (referencia, cantidad) {
        if (cantidad > 0) {
          return false
        }
        const me = this
        $(me.$refs[referencia]).find('.item-description').fadeOut(250)
      },
      activarHover () {
        $('.item-img-container.sin').hover(
          function () {
            $(this).find('.item-description').fadeIn(250)
          },
          function () {
            $(this).find('.item-description').fadeOut(250)
          }
        )
      },
      setDia: function (dia) {
        var me = this
        me.diaActivo = dia
        me.idxDia = me.dias.indexOf(dia)
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      },
      setProveedorActivo (id) {
        const me = this
        me.asignacionActiva = me.proveedores.find((proveedor) => {
          return proveedor._id === id
        })
        me.comboActivo = me.asignacionActiva.combo._id
        me.subsidio = me.asignacionActiva.subsidio
        localforage.setItem(`proveedor-activo-${me.user._id}`, me.asignacionActiva, () => {
          localforage.setItem(`subsidio-activo-${me.user._id}`, me.subsidio, () => {
            console.log('Subsidio', me.subsidio, me.asignacionActiva)
          })
        })
      },
      toggleCategoria: function (idxItemMenu, idxCategoria, evt) {
        $('#tabCategoria-' + idxItemMenu + '-' + idxCategoria).toggleClass('hidden')
        evt.target.classList.toggle('fa-chevron-down')
      },
      togglePedido: function () {
        this.$refs.themeConfig.classList.toggle('show')
      },
      toggleSideBar: function () {
        $('body').toggleClass('show_sidebar')
      }
    },
    /*
    updated: function () {
      $('.item-img-container.sin').hover(
        function () {
          $(this).find('.item-description').fadeIn(250)
        },
        function () {
          $(this).find('.item-description').fadeOut(250)
        }
      )
    },  */
    watch: {
      pedidosProgramados (newVal, oldVal) {
        this.cargarTooltips()
      }
    },
    destroyed () {
      $('body').removeClass('user-sesion daily-menu')
    }
  }
</script>
<style scoped>
  header.calendar {
    top: 50px;
    z-index: 99;
    height: 63px;
    border-bottom: 5px solid #EEEEEE;
  }
  .botonera .btn {
    margin-left: 5px;
    margin-right: 5px;
  }
  .botonera .btn i {
    font-size: 1em;
  }
  .menu-item .item-img {
    cursor: default;
  }
  .nav-pills {
    width: 100%;
    text-align: center;
  }
  .nav-pills > li {
    float: none;
    display: inline-block;
  }
  .nav-pills > li > a {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .nav-pills > li.active > a, .nav-pills > li.active > a:hover, .nav-pills > li.active > a:focus {
    color: #fff;
    background-color: #93A512;
  }
  .tippy-tooltip.honeybee-theme {
    /* Your styling here. Example: */
    background-color: orange;
  }
</style>



// WEBPACK FOOTER //
// Menu.vue?ab120084